// extracted by mini-css-extract-plugin
export default {"headerContainer":"styles_headerContainer__Fcj4P","headerOrganisationName":"styles_headerOrganisationName__ONaRH","selectorCurrent":"styles_selectorCurrent__zsFlg"};